import { FC } from 'react';

interface ShoppingItemDesktopProps {
  title: string;
  icon: React.ReactElement;
  bottomContent?: React.ReactElement;
  details: React.ReactElement;
  pricing: React.ReactElement;
  imageUrl?: string;
}

export const ShoppingItemDesktop: FC<ShoppingItemDesktopProps> = ({
  title,
  icon,
  bottomContent,
  details,
  pricing,
  imageUrl,
}) => {
  return (
    <div className="flex flex-row items-center mb-4">
      <div className="py-4 pl-6 mr-4 bg-white border rounded-lg shadow grow border-sami-card-border hover:shadow-md">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row gap-4">
            {imageUrl && (
              <div className="flex items-center">
                <img className="w-10" src={imageUrl} />
              </div>
            )}
            <div className="flex flex-col pr-4 md:pr-12">
              <div className="text-base font-bold leading-tight text-text-dark">{title}</div>
              {details}
            </div>
          </div>
          <div className="flex flex-col items-end mx-6 text-end shrink-0">{pricing}</div>
        </div>
        {bottomContent}
      </div>
      {icon}
    </div>
  );
};
